import { render, staticRenderFns } from "./OperatnOspiteInfo.vue?vue&type=template&id=7d6807f4&scoped=true&"
import script from "./OperatnOspiteInfo.vue?vue&type=script&lang=ts&"
export * from "./OperatnOspiteInfo.vue?vue&type=script&lang=ts&"
import style0 from "./OperatnOspiteInfo.vue?vue&type=style&index=0&id=7d6807f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d6807f4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VContainer,VForm,VRow,VTextField})
